export default "__VITE_ASSET__CUo8Cka7__"